import React from 'react';
import { FaCubes, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { stockEffectHint } from '../../../utils/companyShipments';
import styles from './CargoTracking.module.css';

const emptyItem = () => ({ stockId: '', stockName: '', quantity: '' });

/**
 * Kargoya bağlı stok kalemleri. Kalemler, kargo ilgili duruma geldiğinde
 * stoğa otomatik işlenir (bkz. utils/companyShipments.js).
 */
const CargoItemsField = ({ items, onChange, stocks, direction, error }) => {
  const updateItem = (index, patch) =>
    onChange(items.map((item, i) => (i === index ? { ...item, ...patch } : item)));

  const handleStockChange = (index, stockId) => {
    const stock = stocks.find((option) => option.id === stockId);
    updateItem(index, { stockId, stockName: stock?.name || '' });
  };

  return (
    <div className={styles.itemsField}>
      <p className={styles.fieldHint}>
        <FaCubes /> {stockEffectHint(direction)}
      </p>

      {items.map((item, index) => {
        const stock = stocks.find((option) => option.id === item.stockId);
        return (
          // Satırların kalıcı kimliği yok; sıra yalnızca ekleme/silmeyle değişir
          <div key={index} className={styles.itemRow}>
            <select
              className={styles.control}
              value={item.stockId}
              onChange={(e) => handleStockChange(index, e.target.value)}
              aria-label="Stok"
            >
              <option value="">Stok seçin...</option>
              {/* Kayıtlı kalemin stok kartı sonradan pasifleşmiş/silinmiş olabilir */}
              {item.stockId && !stock && <option value={item.stockId}>{item.stockName}</option>}
              {stocks.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name} (kalan: {option.remaining})
                </option>
              ))}
            </select>
            <input
              type="number"
              min="0"
              step="any"
              className={`${styles.control} ${styles.itemQuantity}`}
              value={item.quantity}
              onChange={(e) => updateItem(index, { quantity: e.target.value })}
              placeholder="Adet"
              aria-label="Adet"
            />
            <button
              type="button"
              className={styles.squareButton}
              onClick={() => onChange(items.filter((_, i) => i !== index))}
              aria-label="Kalemi kaldır"
            >
              <FaTrashAlt />
            </button>
          </div>
        );
      })}

      {error && <span className={styles.errorText}>{error}</span>}

      <button
        type="button"
        className={styles.ghostButton}
        onClick={() => onChange([...items, emptyItem()])}
      >
        <FaPlus /> Stok kalemi ekle
      </button>
    </div>
  );
};

export default CargoItemsField;
